import React, { useEffect } from 'react';
export function Catalog() {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-atomic-black" data-id="element-629">
      {/* Full-bleed iframe container */}
      <div className="w-full" style={{
      height: 'calc(100vh - 130px)'
    }} data-id="element-630">
        <iframe src="https://viewer.zoomcatalog.com/s-and-s-whats-new-2026" title="Product Catalog" className="w-full h-full border-0" style={{
        display: 'block',
        margin: 0,
        padding: 0
      }} allowFullScreen data-id="element-631" />
      </div>
    </div>;
}